export var SUDStatusKind;
(function (SUDStatusKind) {
    SUDStatusKind["Flagged"] = "flagged";
    SUDStatusKind["HasAccess"] = "has_access";
    SUDStatusKind["ReferredByProvider"] = "referred_by_provider";
    SUDStatusKind["Enrolled"] = "enrolled";
})(SUDStatusKind || (SUDStatusKind = {}));
